/** Home pública do domínio. Bolão fora do ar; código permanece no app do PC. */
export default function PaginaPublica() {
  return (
    <main
      style={{
        minHeight: "100vh",
        margin: 0,
        padding: "2.5rem 1.25rem",
        fontFamily: "Segoe UI, system-ui, sans-serif",
        background: "#f6f3ee",
        color: "#111",
      }}
    >
      <div style={{ maxWidth: 640, margin: "0 auto" }}>
        <h1 style={{ margin: "0 0 1rem", fontSize: "1.6rem" }}>Não está mais disponível</h1>
        <p style={{ lineHeight: 1.65, color: "#1e1e1e" }}>
          Este conteúdo não está mais disponível neste endereço.
        </p>
      </div>
    </main>
  );
}
